import { createComponent } from '@carvana/merch-components';

export const SectionHeaderLarge = createComponent('h2', {
  className: 'leading-6 text-[20px] text-blue-6'
});

export const SectionHeaderSmall = createComponent('h3', {
  className: 'flex gap-4 items-center t-header-xs text-blue-6'
});

export const RequirementsList = createComponent('ul', {
  className: 'flex flex-col gap-4 list-none mb-0 px-0 text-grey-5 text-sm'
});
